module.exports = __webpack_public_path__ + "static/media/am.958734f8.svg";